<div class="row no-gutters p-2 mx-5 mt-3">
    <div class="col" *ngIf="model">
        <div class="py-2">
            <label
            for="OrderBy">{{'GroupClassDetails.OrderBy' | translate}}</label>
            <bcu-drop-down-cf2 [multiple]="false" id="orderBy"
                [formControl]="orderBy" [options]="orderByValues" valueKey="key"
                displayKey="value">
            </bcu-drop-down-cf2>
        </div>

        <div class="pb-2">
            <span class="text-bayclub-blue" translate>GroupClassDetails.ParticipantLimitLabel</span>
            <span class="text-dimmed" *ngIf="model.capacity"> {{ model.capacity }}</span>
            <span class="text-dimmed" *ngIf="!model.capacity" class="text-greyed-out"
                translate>General.NotSetValue</span>
        </div>
        <div class="pb-3 text-dimmed">
            <div *ngIf="attendensModel">
                <div class="row">
                    <div class="col">
                        <div class="participant-item" *ngFor="let item of getActive(); let i = index">
                            <span class="mr-2">{{ i + 1 }}. {{ item.fullName }}
                                ({{'GroupClassDetails.ParticipantMemberIdLabel' | translate}}: {{item.memberId}},
                                {{'GroupClassDetails.ParticipantEmailLabel' | translate}}: {{item.email}})
                                <span *ngIf="item.resourceLabel">({{item.resourceLabel}})</span>
                            </span>
                            <span *ngIf="isMarkedAsNoShow(item)"
                                translate>GroupClassDetails.ParticipantMarkedAsNoShow</span>
                            <span class="pl-2 ml-2 ic-trash-blue remove-text" (click)="cancelBooking(item.bookingId)">
                                Remove</span>
                        </div>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="cancelledBookingsExists">
                    <div class="col">
                        <strong class="text-dimmed"
                            translate>{{'GroupClassDetails.CancelledParticipants' | translate}}</strong>
                        <div *ngFor="let item of getCancelled(); let i = index">
                            <span class="mt-1">
                                <span> {{ item.fullName }} </span>
                                <span *ngIf="item.cancelledAt">({{item.cancelledAt | bcDateTime: 'MMM DD hh:mm:ss A'}}
                                    <span *ngIf="showCancelledBy(item)">,{{'GroupClassDetails.CancelledBy' |
                                        translate}}{{item.cancelledBy}}</span>)

                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-greyed-out" *ngIf="attendensModel && attendensModel.items.length == 0" translate>
                GroupClassDetails.NoBookingsYet
            </div>
            <bcu-local-spinner [size]="25" [visible]="!attendensModel" *ngIf="!attendensModel">
            </bcu-local-spinner>
        </div>
    </div>
</div>
